import { gql } from '@apollo/client';

export const CREATE_ASSET = gql`
    mutation createAsset($input: AssetInput!) {
        result: createAsset(input: $input) {
          id
          name
          url
          mimetype
          encoding
          createdAt
          locales
        }
    }
`;

export default CREATE_ASSET;
